import { isSSR } from "./client-server-helper";
import GTMHelper from "helpers/gtm";
import { getUserId, userDataSelector } from "../components/source/hoc/with-user-data";

/**
 * Sets up various 3rd party integrations that may or may not be configured, typically by listening for state changes in redux
 * @param store The redux store to listen for changes on
 */
export default function setupAnalyticsIntegrations(store) {
  if (isSSR()) {
    return;
  }

  const setInitialAttributesFromRedux = state => {
    const userData = userDataSelector(state);
    const userId = getUserId(userData);
    if (userId) {
      window.Sentry?.setUser({ id: userId });
      GTMHelper.pushToDataLayer({ userId: userId });
    }
  };

  // variables to hold previous state values
  let previousUserId;
  const handleStateChange = function () {
    const state = store.getState();
    const userData = userDataSelector(state);
    const userId = getUserId(userData);

    if (userId !== previousUserId) {
      window.Sentry?.setUser({ id: userId });
      GTMHelper.pushToDataLayer({ userId: userId });
    }
  };

  setInitialAttributesFromRedux(store.getState());
  store.subscribe(handleStateChange);
}
